export default __webpack_public_path__ + "static/media/card-13.0d921a5c.png";